import type { GameManual } from '../../types';
import { diunaImperiumChapters, diunaImperiumFirstGame } from './content';
import { consolidateAddonChapters } from '../perfect-quality/consolidateAddonChapters';

export const diunaImperiumManual: GameManual = {
  chapters: consolidateAddonChapters(
    diunaImperiumChapters,
    'immortality',
    'Nieśmiertelność'
  ),
  firstGameSteps: diunaImperiumFirstGame,
  addons: [
  {
    "id": "immortality",
    "name": "Nieśmiertelność"
  }
],
};

export * from './content';
export * from './blockers';
export * from './faq';
export * from './glossary';
export * from './guided';
export * from './quickReference';
export * from './commonMistakes';
export * from './scoring';
export * from './components';
export * from './icons';
export * from './search';
export * from './validate';
